import { Injectable } from '@angular/core';
import { MatIconRegistry } from '@angular/material/icon';
import { DomSanitizer } from '@angular/platform-browser';

@Injectable({
    providedIn: 'root',
})
export class IconService {
    private readonly icons: string[] = [
        'apartment',
        'arrow-left',
        'book',
        'business',
        'calendar',
        'chalkboard-teacher',
        'copy',
        'close',
        'empty-feedback',
        'empty-state',
        'envelope',
        'expand_less',
        'expand_more',
        'google-logo',
        'clock',
        'hamburg-menu',
        'home',
        'iitb-eo-logo',
        'mobile',
        'receipt',
        'schedule',
        'school',
        'search',
        'success-person',
        'user-in-circle',
        'user',
        'work',
        'download',
        'share',
        'sort',
        'LinkedIn',
        'google-logo',
        'open-faculty-profile',
        'target',
        'file-magnify',
        'hand-piece',
        'sheild-check',
        'open-in-new',
        'hamburg-menu',
        'instagram',
        'whatsapp',
        'x',
        'facebook',
    ];

    constructor(
        private readonly iconRegistry: MatIconRegistry,
        private readonly sanitizer: DomSanitizer,
    ) {
        this.registerIcons();
    }

    private registerIcons(): void {
        this.icons.forEach((icon) => {
            this.iconRegistry.addSvgIcon(icon, this.sanitizer.bypassSecurityTrustResourceUrl(`assets/svg/${icon}.svg`)); //NOSONAR
        });
    }
}
